var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('avue-crud',{ref:"crud",attrs:{"data":_vm.tableList,"option":_vm.option,"table-loading":_vm.showLoading,"page":_vm.page},on:{"update:page":function($event){_vm.page=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }